import { defineComponent, VNode } from "vue";
import Svg from "../core/svg";
import { VueEmit, VueProp } from "../core/vueHelpers";
import * as Classes from "./classes";


export default /*#__PURE__*/ defineComponent(
{
    name: "treebrowseBreadcrumb",
    props:
    {
        moduleName: VueProp(String),
        objectName: VueProp(String),
        positionObjectPath: VueProp(String),
        displayName: VueProp(String),
        isOneToMany: VueProp(Boolean),
        index: VueProp(Number)
    },
    emits:
    {
        "breadcrumbClicked": VueEmit<(index: number) => void>()
    },
    render(): VNode
    {  
        const icon = this.isOneToMany ? "OneToMany" : "OpenFolderAlt";

        return <span class={{ [Classes.breadcrumbSpan]: true }} onClick={() => this.$emit("breadcrumbClicked", this.index)}>
            <Svg name={icon} type="TreeBrowse" showHoverEffect={false} />
            <span class=
                {{
                    [Classes.breadcrumbLabel]: true,
                    [Classes.treeBreadcrumb]: true,
                    [Classes.selectable]: true,
                    [Classes.treeBrowseSectionHeader]: true
                }}
            >
                {this.displayName}
            </span>
        </span>
    }
}); 

